


  const data = [
    {
      imgelink:
        "https://www.thrillophilia.com/blog/wp-content/uploads/2021/10/1-12-2-600x338.jpg",
    },
    {
      imgelink:
        "https://media1.thrillophilia.com/filestore/4h51dyp9m4vie5afut9a8jihlxno_unnamed%20(2).jpg?w=800&h=460&dpr=2.0",
    },
    {
      imgelink:
        "https://media2.thrillophilia.com/images/photos/000/081/902/original/1464085701_4784417698_fec7b270ed_b.jpg?w=753&h=450&dpr=1.5",
    },
    {
      imgelink:
        "https://media2.thrillophilia.com/images/photos/000/081/844/original/1464082989_6736944607_63cf482deb_b.jpg?w=753&h=450&dpr=1.5",
    },
    {
      imgelink:
        "https://media1.thrillophilia.com/filestore/g7ia5xgj74exj29gi7wte99l5xd6_shutterstock_731136526.jpg?w=305&h=230&dpr=2.0",
    },
    
  ];
 
  export default  data;